<template>
  <el-dialog
    ref="elDialog"
    v-model="dialogVisible"
    :close-on-click-modal="closeOnClickModal"
    v-bind="attrs"
  >
    <template
      v-for="(index, name) in $slots"
      #[name]
    >
      <slot :name="name" />
    </template>
  </el-dialog>
</template>

<script>
import popup from '@/mixins/popup'
import ElDialog from '@/components/dialog-v2'

export default {
  name: 'MsDialog',

  mixins: [popup],

  components: {
    ElDialog
  },

  inheritAttrs: false,

  props: {
    handleBeforeClose: {
      type: Function,
      default: null
    },

    closeOnClickModal: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      beforeCloseFunc: null
    }
  },

  computed: {
    attrs () {
      return {
        ...this.$attrs,
        'before-close': this.onBeforeClose
      }
    }
  },

  methods: {
    /**
     * @description Lắng nghe sự kiện
     * @author PHNam
     */
    addListener (event, handler) {
      this.$refs.elDialog.$on(event, handler)
    },

    /**
     * @description Bỏ lắng nghe sự kiện
     * @author PHNam
     */
    removeListener (event, handler) {
      this.$refs.elDialog.$off(event, handler)
    },

    /**
     * @description Trước khi đóng dialog
     * @author PHNam
     */
    onBeforeClose (hide) {
      if (typeof this.handleBeforeClose === 'function') {
        this.beforeClose(hide)
      } else if (typeof this.beforeCloseFunc === 'function') {
        this.beforeCloseFunc(hide)
      } else {
        hide()
      }
    },

    /**
     * @description Mở dialog
     * @author PHNam
     */
    open () {
      this.dialogVisible = true
    },

    /**
     * @description Đóng dialog
     * @author PHNam
     */
    close () {
      this.dialogVisible = false
    },

    /**
     * @description Ẩn dialog, hàm này sẽ chạy qua hàm trước khi đóng dialog
     * @author PHNam
     */
    hide () {
      this.$refs.elDialog.hide()
    },

    /**
     * @description Mở dialog
     * @param func Hàm xử lý khi dialog đóng lại
     * @author PHNam
     */
    setBeforeCloseFunc (func) {
      this.beforeCloseFunc = func
    }
  }
}
</script>

<style lang="scss" scoped></style>
